// HKDSE 2016 Paper 1 Knowledge Graph Samples - Complete Set Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2016Samples_complete_part2 = {
  statistics: [
    {
      id: 'hkdse2016_statistics_01',
      problem: "The following frequency distribution table and cumulative frequency distribution table both show the distribution of the heights of plants in a garden. Table 1 - Frequency Distribution: Height (m) | Frequency 0.1 - 0.3 | a 0.4 - 0.6 | 4 0.7 - 0.9 | b 1.0 - 1.2 | c 1.3 - 1.5 | 15 1.6 - 1.8 | 3 Table 2 - Cumulative Frequency Distribution: Height less than (m) | Cumulative Frequency 0.35 | 2 0.65 | x 0.95 | 13 1.25 | y 1.55 | 37 1.85 | z (a) Find $x$, $y$ and $z$. (b) If a plant is randomly selected from the garden, find the probability that the selected plant has height less than $1.25$ m but not less than $0.65$ m.",
      problemType: "statistics_frequency_distribution",
      difficulty: "intermediate",
      description: "Working with frequency and cumulative frequency distributions",
      graphData: {
        nodes: [
          {
            id: "frequency_table",
            name: "Frequency Table",
            type: "concepts",
            description: "Understanding frequency distribution",
            value: "Height intervals with frequencies",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "cumulative_frequency",
            name: "Cumulative Frequency",
            type: "concepts",
            description: "Understanding cumulative frequency",
            value: "Running total of frequencies",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "step1_find_a",
            name: "Step 1: Find a",
            type: "steps",
            description: "From cumulative frequency at 0.35",
            value: "a = 2",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "step2_find_b",
            name: "Step 2: Find b",
            type: "steps",
            description: "From cumulative frequency at 0.95",
            value: "2 + 4 + b = 13 → b = 7",
            importance: 8,
            x: -200, y: 0, z: 25
          },
          {
            id: "step3_find_c",
            name: "Step 3: Find c",
            type: "steps",
            description: "From cumulative frequency at 1.25",
            value: "2 + 4 + 7 + c = y",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "step4_find_x",
            name: "Step 4: Find x",
            type: "steps",
            description: "Cumulative frequency at 0.65",
            value: "x = 2 + 4 = 6",
            importance: 8,
            x: 200, y: 0, z: 25
          },
          {
            id: "step5_find_y",
            name: "Step 5: Find y",
            type: "steps",
            description: "Cumulative frequency at 1.25",
            value: "y = 2 + 4 + 7 + c",
            importance: 8,
            x: -200, y: 100, z: -15
          },
          {
            id: "step6_find_z",
            name: "Step 6: Find z",
            type: "steps",
            description: "Total frequency",
            value: "z = 2 + 4 + 7 + c + 15 + 3",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_b_probability",
            name: "Part (b): Probability",
            type: "steps",
            description: "Calculate required probability",
            value: "P(0.65 ≤ height < 1.25) = (y - x)/total",
            importance: 9,
            x: 200, y: 100, z: -15
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) x=6, y=22, z=40 (b) 16/40 = 0.4",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "frequency_table", to: "step1_find_a", type: "enables", strength: 8 },
          { from: "cumulative_frequency", to: "step2_find_b", type: "enables", strength: 8 },
          { from: "step1_find_a", to: "step2_find_b", type: "enables", strength: 8 },
          { from: "step2_find_b", to: "step3_find_c", type: "enables", strength: 8 },
          { from: "step3_find_c", to: "step4_find_x", type: "enables", strength: 8 },
          { from: "step4_find_x", to: "step5_find_y", type: "enables", strength: 8 },
          { from: "step5_find_y", to: "step6_find_z", type: "enables", strength: 8 },
          { from: "step4_find_x", to: "part_b_probability", type: "enables", strength: 9 },
          { from: "step5_find_y", to: "part_b_probability", type: "enables", strength: 9 },
          { from: "step6_find_z", to: "part_b_probability", type: "enables", strength: 8 },
          { from: "part_b_probability", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "step4_find_x", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "step5_find_y", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "step6_find_z", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  geometry: [
    {
      id: 'hkdse2016_geometry_01',
      problem: "The coordinates of points $A$ and $B$ are $(5, 7)$ and $(13, 1)$ respectively. Let $P$ be a moving point on the rectangular coordinate plane such that $P$ is equidistant from $A$ and $B$. Let the locus of $P$ be $\\Gamma$. (a) Find the equation of $\\Gamma$. (b) $\\Gamma$ intersects the $x$-axis and $y$-axis at $H$ and $K$ respectively. Let the origin be $O$. Let $C$ be the circle passing through $O$, $H$ and $K$. Someone claims that the circumference of circle $C$ exceeds $30$. Is this claim correct? Explain your answer.",
      problemType: "geometry_locus_circle",
      difficulty: "intermediate",
      description: "Finding locus and circle properties",
      graphData: {
        nodes: [
          {
            id: "equidistant_locus",
            name: "Equidistant Locus",
            type: "concepts",
            description: "Locus of points equidistant from two points",
            value: "Perpendicular bisector of AB",
            importance: 10,
            x: -200, y: -200, z: 0
          },
          {
            id: "perpendicular_bisector",
            name: "Perpendicular Bisector",
            type: "concepts",
            description: "Line perpendicular to AB at midpoint",
            value: "Midpoint and negative reciprocal slope",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "step1_find_midpoint",
            name: "Step 1: Find Midpoint",
            type: "steps",
            description: "Find midpoint of AB",
            value: "Midpoint = ((5+13)/2, (7+1)/2) = (9, 4)",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "step2_find_slope_ab",
            name: "Step 2: Find Slope AB",
            type: "steps",
            description: "Calculate slope of AB",
            value: "Slope AB = (1-7)/(13-5) = -6/8 = -3/4",
            importance: 8,
            x: -200, y: 0, z: 25
          },
          {
            id: "step3_find_perpendicular_slope",
            name: "Step 3: Perpendicular Slope",
            type: "steps",
            description: "Find slope of perpendicular bisector",
            value: "Perpendicular slope = 4/3",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "step4_equation_gamma",
            name: "Step 4: Equation of Γ",
            type: "steps",
            description: "Write equation using point-slope form",
            value: "y - 4 = (4/3)(x - 9)",
            importance: 9,
            x: 200, y: 0, z: 25
          },
          {
            id: "part_a_final_equation",
            name: "Part (a): Final Equation",
            type: "steps",
            description: "Simplify to standard form",
            value: "4x - 3y - 24 = 0",
            importance: 10,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_b_find_intersections",
            name: "Part (b): Find Intersections",
            type: "steps",
            description: "Find H and K",
            value: "H(6, 0), K(0, -8)",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_circle_properties",
            name: "Part (b): Circle Properties",
            type: "steps",
            description: "Find circle through O, H, K",
            value: "Use three points to find circle",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "part_b_circumference",
            name: "Part (b): Circumference",
            type: "steps",
            description: "Calculate circumference",
            value: "Circumference = 2πr",
            importance: 8,
            x: 0, y: 400, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) 4x - 3y - 24 = 0 (b) Yes, circumference > 30",
            importance: 10,
            x: 0, y: 500, z: 0
          }
        ],
        links: [
          { from: "equidistant_locus", to: "perpendicular_bisector", type: "equals", strength: 10 },
          { from: "perpendicular_bisector", to: "step1_find_midpoint", type: "enables", strength: 8 },
          { from: "step1_find_midpoint", to: "step2_find_slope_ab", type: "enables", strength: 8 },
          { from: "step2_find_slope_ab", to: "step3_find_perpendicular_slope", type: "enables", strength: 8 },
          { from: "step3_find_perpendicular_slope", to: "step4_equation_gamma", type: "enables", strength: 9 },
          { from: "step4_equation_gamma", to: "part_a_final_equation", type: "leads to", strength: 10 },
          { from: "part_a_final_equation", to: "part_b_find_intersections", type: "enables", strength: 8 },
          { from: "part_b_find_intersections", to: "part_b_circle_properties", type: "enables", strength: 8 },
          { from: "part_b_circle_properties", to: "part_b_circumference", type: "leads to", strength: 8 },
          { from: "part_a_final_equation", to: "final_answer", type: "contributes to", strength: 10 },
          { from: "part_b_circumference", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  mensuration: [
    {
      id: 'hkdse2016_mensuration_01',
      problem: "A certain upright circular conical container contains some milk. The container is then placed vertically. The depth of milk in the container is $12$ cm. Later, $444\\pi$ cm$^3$ of milk is poured into the container without any milk overflowing. He now knows that the depth of milk in the container is $16$ cm. (a) Express the final volume of milk in the container in terms of $\\pi$. (b) Later someone claims that the final area of the curved surface wetted by the container is at least $800$ cm$^2$. Do you agree? Explain your answer.",
      problemType: "mensuration_cone_volume",
      difficulty: "intermediate",
      description: "Solving cone volume and surface area problems",
      graphData: {
        nodes: [
          {
            id: "cone_volume_formula",
            name: "Cone Volume Formula",
            type: "concepts",
            description: "Volume of cone = ⅓πr²h",
            value: "V = ⅓πr²h",
            importance: 10,
            x: -200, y: -200, z: 0
          },
          {
            id: "similar_cones",
            name: "Similar Cones",
            type: "concepts",
            description: "Understanding similar cones",
            value: "Ratio of volumes = (ratio of heights)³",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "step1_volume_ratio",
            name: "Step 1: Volume Ratio",
            type: "steps",
            description: "Find ratio of volumes",
            value: "V₁/V₂ = (12/16)³ = (3/4)³ = 27/64",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "step2_find_initial_volume",
            name: "Step 2: Find Initial Volume",
            type: "steps",
            description: "Use volume difference",
            value: "V₂ - V₁ = 444π",
            importance: 8,
            x: -200, y: 0, z: 25
          },
          {
            id: "step3_solve_for_volumes",
            name: "Step 3: Solve for Volumes",
            type: "steps",
            description: "Solve system of equations",
            value: "V₁ = 972π, V₂ = 1416π",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_a_final_volume",
            name: "Part (a): Final Volume",
            type: "steps",
            description: "Final volume of milk",
            value: "1416π cm³",
            importance: 10,
            x: 200, y: 0, z: 25
          },
          {
            id: "part_b_curved_surface",
            name: "Part (b): Curved Surface",
            type: "steps",
            description: "Find curved surface area",
            value: "A = πrl where l = √(r² + h²)",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "part_b_calculation",
            name: "Part (b): Calculation",
            type: "steps",
            description: "Calculate surface area",
            value: "Find r from volume, then calculate A",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_comparison",
            name: "Part (b): Comparison",
            type: "steps",
            description: "Compare with 800 cm²",
            value: "Check if A ≥ 800",
            importance: 8,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) 1416π cm³ (b) Yes, agree",
            importance: 10,
            x: 0, y: 400, z: 0
          }
        ],
        links: [
          { from: "cone_volume_formula", to: "step1_volume_ratio", type: "enables", strength: 9 },
          { from: "similar_cones", to: "step1_volume_ratio", type: "enables", strength: 9 },
          { from: "step1_volume_ratio", to: "step2_find_initial_volume", type: "enables", strength: 8 },
          { from: "step2_find_initial_volume", to: "step3_solve_for_volumes", type: "leads to", strength: 9 },
          { from: "step3_solve_for_volumes", to: "part_a_final_volume", type: "leads to", strength: 10 },
          { from: "part_a_final_volume", to: "part_b_curved_surface", type: "enables", strength: 8 },
          { from: "part_b_curved_surface", to: "part_b_calculation", type: "leads to", strength: 8 },
          { from: "part_b_calculation", to: "part_b_comparison", type: "leads to", strength: 8 },
          { from: "part_a_final_volume", to: "final_answer", type: "contributes to", strength: 10 },
          { from: "part_b_comparison", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  statistics_advanced: [
    {
      id: 'hkdse2016_statistics_advanced_01',
      problem: "The following bar chart shows the distribution of ages of a group of children, where $a > 11$ and $4 < b < 10$. The median age of the group of children is $7.5$. Bar chart description: The chart shows age distribution with x-axis showing ages 6, 7, 8, 9, 10 and y-axis showing number of children. The bars show frequencies: age 6 has frequency 11, age 7 has frequency $a$, age 8 has frequency 11, age 9 has frequency $b$, age 10 has frequency 4. (a) Find $a$ and $b$. (b) Four more children are now added to the group. It is known that the ages of these four children are all different and the range of ages of the group of children remains unchanged. Find (i) the greatest possible median age of the group of children, (ii) the smallest possible mean age of the group of children.",
      problemType: "statistics_median_mean",
      difficulty: "intermediate",
      description: "Working with median, mean and range in statistics",
      graphData: {
        nodes: [
          {
            id: "frequency_distribution",
            name: "Frequency Distribution",
            type: "concepts",
            description: "Age distribution with frequencies",
            value: "6:11, 7:a, 8:11, 9:b, 10:4",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "median_concept",
            name: "Median Concept",
            type: "concepts",
            description: "Middle value when data is ordered",
            value: "Median = 7.5",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "step1_find_total",
            name: "Step 1: Find Total",
            type: "steps",
            description: "Calculate total frequency",
            value: "Total = 11 + a + 11 + b + 4 = 26 + a + b",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "step2_median_position",
            name: "Step 2: Median Position",
            type: "steps",
            description: "Find position of median",
            value: "Median position = (26 + a + b + 1)/2",
            importance: 8,
            x: -200, y: 0, z: 25
          },
          {
            id: "step3_solve_for_a_b",
            name: "Step 3: Solve for a and b",
            type: "steps",
            description: "Use median condition",
            value: "a = 12, b = 5",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_b_range_constraint",
            name: "Part (b): Range Constraint",
            type: "steps",
            description: "Range remains unchanged",
            value: "Range = 10 - 6 = 4",
            importance: 8,
            x: 200, y: 0, z: 25
          },
          {
            id: "part_b_max_median",
            name: "Part (b): Max Median",
            type: "steps",
            description: "Find greatest possible median",
            value: "Add 4 children with ages 6,7,8,9",
            importance: 8,
            x: -200, y: 100, z: -15
          },
          {
            id: "part_b_min_mean",
            name: "Part (b): Min Mean",
            type: "steps",
            description: "Find smallest possible mean",
            value: "Add 4 children with ages 6,6,6,6",
            importance: 8,
            x: 0, y: 100, z: -15
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Complete solution",
            value: "(a) a=12, b=5 (b) (i) 7.5 (ii) 6.8",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "frequency_distribution", to: "step1_find_total", type: "enables", strength: 8 },
          { from: "median_concept", to: "step2_median_position", type: "enables", strength: 8 },
          { from: "step1_find_total", to: "step2_median_position", type: "enables", strength: 8 },
          { from: "step2_median_position", to: "step3_solve_for_a_b", type: "leads to", strength: 9 },
          { from: "step3_solve_for_a_b", to: "part_b_range_constraint", type: "enables", strength: 8 },
          { from: "part_b_range_constraint", to: "part_b_max_median", type: "enables", strength: 8 },
          { from: "part_b_range_constraint", to: "part_b_min_mean", type: "enables", strength: 8 },
          { from: "step3_solve_for_a_b", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_max_median", to: "final_answer", type: "contributes to", strength: 8 },
          { from: "part_b_min_mean", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ]
}; 